import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Autocomplete, Box, Breadcrumbs, Button, CircularProgress, Grid, IconButton, Link, ListItem, ListItemText, MenuItem, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { useFormik } from 'formik';
import * as yup from 'yup';
import DocumentosAssociados from '../../components/documentosAssociados';
import LinhasCotacao from '../../components/linhasCotacao';
import moment from 'moment';
import { useModal } from 'mui-modal-provider';
import { CotacaoDialog } from './dialog';
import InfoContactoCliente from '../../components/infoContactoCliente';
import historicoAlteracoes from '../../components/history/handleHistory';
import { MdiIcon } from '@components';
import { mdiContentSave, mdiHistory } from '@mdi/js';
import History from '../../components/history/history';
import { StepperComponent } from '../../../interface/components/Stepper';
import { TextEditor } from '@components';
const validationSchema = yup.object().shape({
//contactoId: yup.number().required('Preenchimento obrigatório'),
//titulo: yup.string().required('Preenchimento obrigatório')
//descricaoPedido: yup.string().required('Preenchimento obrigatório')
});
const CrmCotacaoForm = ({ $state, CrmService, AuthorizationService }) => {
    const [pageLoad, setPageLoad] = useState(true);
    const [userId, setUserId] = useState(0); // user logado
    // Cotação
    const [cotacaoOriginal, setCotacaoOriginal] = useState(null);
    const [cotacao, setCotacao] = useState(null);
    const [currentState, setCurrentState] = useState(10);
    const [estados, setEstados] = useState([]);
    const [departamentos, setDepartamentos] = useState([]); //
    const [motivos, setMotivos] = useState([]);
    // Documentos
    const [documentosList, setDocumentosList] = useState([]);
    const [docCotacao, setDocCotacao] = useState(null);
    const [files, setFiles] = useState([]);
    const [docsReadOnly, setDocsReadOnly] = useState(false);
    const [empresa, setEmpresa] = useState(null); // Empresa (cliente)
    const [contacto, setContacto] = useState(null); // Pessoa (contacto) associado à cotação
    // stepper
    const [steps, setSteps] = useState([]);
    const [activeStep, setActiveStep] = useState(0);
    //const [linha, setLinha] = useState<ICrmLinhaCotacao[]>([]);
    const [openHistory, setOpenHistory] = useState(false);
    const [showHistory, setShowHistory] = useState(false);
    const [hist, setHist] = useState([]);
    // AutoComplete
    const [options, setOptions] = useState();
    // Workflow
    const [grupo1, setGrupo1] = useState(true); // Disable -> Contacto, título, Descrição do pedido
    const [disableGrupo2, setDisableGrupo2] = useState(false); // Disable -> Caracterização da cotação
    const [showGrupo2, setShowGrupo2] = useState(false); // Mostrar -> Caracterização da cotação
    const [showLinhasCotação, setShowLinhasCotação] = useState(false); // Mostrar -> Tabela Linhas de cotção
    const [showMotivoArquivamento, setShowMotivoArquivamento] = useState(false); // Mostrar -> Tabela Linhas de cotção
    const [disableButton, setDisableButton] = useState(false); // Disable workflow buttons
    const tituloRef = useRef(null);
    const [tituloError, setTituloError] = useState(null);
    const descricaoPedidoRef = useRef(null);
    const [descricaoPedidoError, setDescricaoPedidoError] = useState(null);
    const motivoArquivamentoRef = useRef(null);
    const [motivoArquivamentoError, setMotivoArquivamentoError] = useState(null);
    const cancelamentoMotivoRef = useRef(null);
    const [cancelamentoMotivoError, setCancelamentoMotivoError] = useState(null);
    const notasDepartamentoExternoRef = useRef(null);
    const [notasDepartamentoExternoError, setNotasDepartamentoExternoError] = useState(null);
    const handleEditorChange = (content, label) => {
        formik.setFieldValue(label, content);
    };
    const { showModal } = useModal();
    const getUserId = async () => {
        try {
            let id = CrmService.getUserId();
            setUserId(id);
        }
        catch (error) {
            console.log('Erro ao obter id do utilizador', error);
        }
    };
    const getEmpresa = async () => {
        try {
            const emp = await CrmService.findEmpresaById($state.params.idEmpresa);
            setEmpresa(emp);
        }
        catch (error) {
            console.log('Error ao obter empresa: ', error);
        }
    };
    const getContactosAssociadosEmpresa = async () => {
        try {
            const cont = await CrmService.getContactosAssociadosEmpresa($state.params.idEmpresa);
            setOptions(cont);
        }
        catch (error) {
            console.log('Error ao obter contactos associados à empresa: ', error);
        }
    };
    const getDepartamentos = async () => {
        try {
            let dep = await CrmService.getDepartamentos();
            setDepartamentos(dep);
        }
        catch (error) {
            console.log('Erro ao obter departamentos', error);
        }
    };
    // get Historico
    const getHistorico = async () => {
        if (cotacao !== null) {
            try {
                const alt = await CrmService.getAlteracoesById($state.params.id);
                const historicoArray = alt.map(h => ({
                    id: h.id,
                    estado: estados.find(e => e.id === h.estadoInicial)?.designacao,
                    user: h.Funcionario?.name,
                    data: h.dataAlteracao,
                    observacoes: h.observacoes,
                    estadoInicial: h.estadoInicial, // Adicionado
                    estadoFinal: h.estadoFinal
                }));
                handleStepper(cotacao, alt);
                if (cotacao?.estadoId === 60) {
                    let arq = historicoArray[historicoArray.length - 1];
                    historicoArray.push({
                        id: arq.id + 1,
                        estado: 'Arquivado',
                        user: arq.user,
                        data: arq.data,
                        observacoes: 'Cotação arquivada.',
                        estadoInicial: 60, // Adicionado
                        estadoFinal: 80
                    });
                }
                if (cotacao?.estadoId === 70) {
                    let concluido = historicoArray[historicoArray.length - 1];
                    historicoArray.push({
                        id: concluido.id + 1,
                        estado: 'Concluído',
                        user: concluido.user,
                        data: concluido.data,
                        observacoes: 'Cotação concluída.',
                        estadoInicial: 70, // Adicionado
                        estadoFinal: 80
                    });
                }
                for (const item of historicoArray) {
                    const idResponsavel = getResponsavelId(item.observacoes);
                    if (idResponsavel) {
                        try {
                            const nome = await CrmService.getNomes([Number(idResponsavel)]);
                            // Substituir o ID pelo nome no texto
                            item.observacoes = item.observacoes.replace(new RegExp(`(Adicionado Responsável no Departamento:\\s*)${idResponsavel}`), `$1${nome[0].nome}`);
                        }
                        catch (error) {
                            console.error(`Erro ao obter nome para ID ${idResponsavel}:`, error);
                        }
                    }
                }
                setHist(historicoArray);
            }
            catch (error) {
                console.error('Erro ao obter Histórico de alterações: ', error);
            }
        }
    };
    const getResponsavelId = (obs) => {
        const match = obs.match(/Adicionado Responsável no Departamento:\s*(\d+)/);
        return match ? match[1] : null;
    };
    const normalWorkflow = () => {
        return [
            { id: 1, designacao: 'Aberto', pessoa: null },
            { id: 2, designacao: 'Avaliação Prévia', pessoa: null },
            { id: 3, designacao: 'Em Cotação', pessoa: null },
            { id: 4, designacao: 'Edição Departamento Externo', pessoa: null },
            { id: 5, designacao: 'Concluído', pessoa: null }
        ];
    };
    const handleStepper = async (c, hist) => {
        let workflow = [];
        let addSteps = false;
        if (c === null) {
            // Workflow Normal
            workflow = normalWorkflow();
            setSteps(workflow);
            return;
        }
        else if (c.estadoId === 40 || c.estadoId === 60) {
            // Workflow Arquivado
            workflow = [
                { id: 1, designacao: 'Aberto', data: c.dataAbertura, pessoa: null },
                { id: 2, designacao: 'Avaliação Prévia', data: c.dataAvaliacao, pessoa: null },
                { id: 3, designacao: 'Em Arquivamento', data: c.dataEmArquivamento, pessoa: null },
                { id: 4, designacao: 'Arquivado', data: c.dataArquivado, pessoa: null }
            ];
        }
        else {
            // Workflow Normal
            if (hist.length == 0 || c.estadoId === 20) {
                workflow = normalWorkflow();
            }
            else {
                addSteps = true;
                if (c.estadoId === 70) {
                    workflow = [{ id: 1, designacao: 'Aberto', data: c.dataAbertura, pessoa: null }];
                }
                else {
                    workflow = [
                        { id: 1, designacao: 'Aberto', data: c.dataAbertura, pessoa: null },
                        { id: 5, designacao: 'Concluído', data: c.dataConclusao, pessoa: null }
                    ];
                }
            }
        }
        if (estados.length > 0 && addSteps) {
            hist.map(h => {
                if (h.estadoFinal != h.estadoInicial) {
                    workflow.push({ id: 0, designacao: estados.find(e => e.id === h.estadoFinal).designacao, data: h.dataAlteracao });
                }
            });
            // ordenar workflow pela data, se não tiver data(null) fica para o fim
            workflow.sort((a, b) => {
                const dataA = a.data ? moment(a.data).valueOf() : Infinity;
                const dataB = b.data ? moment(b.data).valueOf() : Infinity;
                return dataA - dataB;
            });
            workflow.map((w, index) => {
                w.id = index + 1;
                if (w.data) {
                    setActiveStep(index);
                }
                if (c.estadoId == 60) {
                    setActiveStep(index + 1);
                }
                if (c.estadoId == 70) {
                    setActiveStep(index + 1);
                }
            });
        }
        else {
            setActiveStep(parseInt(cotacao.estadoId.toString()[0]) - 1);
        }
        // array dos ids, das pessoas (sem repetições)
        const idsPessoas = Array.from(new Set(hist
            .map((h, index) => {
            return h.funcionarioId;
        })
            .filter(Boolean)));
        // get nomes dos funcionarios para o workflow
        let n = await getNomes(idsPessoas);
        let i = 0;
        hist.map(h => {
            if (h.estadoFinal !== h.estadoInicial) {
                if (workflow[i].data !== null) {
                    const pessoa = n.find(p => p.id === h.funcionarioId);
                    workflow[i].pessoa = pessoa ? pessoa.nome : '';
                }
                i++;
            }
            if (h.estadoFinal === 60 || h.estadoFinal === 70) {
                workflow[i].pessoa = n.find(p => p.id === h.funcionarioId).nome;
                workflow[i].data = h.dataAlteracao;
            }
        });
        setSteps(workflow);
        setPageLoad(false);
    };
    const getNomes = async (x) => {
        let nomes;
        try {
            nomes = await CrmService.getNomes(x);
        }
        catch (error) {
            console.log('Erro ao obter nomes dos colaboradores: ', error);
        }
        return nomes;
    };
    const getEstados = async () => {
        try {
            const estados = await CrmService.getEstadosCotacao();
            setEstados(estados);
        }
        catch (error) {
            console.log('Error ao obter estados da cotação:', error);
        }
    };
    const getContacto = async (id) => {
        try {
            const c = await CrmService.findPessoaById(id);
            setContacto(c);
        }
        catch (error) {
            console.log('Error ao obter contacto', error);
        }
    };
    const fetchData = async () => {
        try {
            const c = await CrmService.getCotacaoById($state.params.id);
            const mot = await CrmService.getMotivosCancelamento();
            setMotivos(mot);
            setCotacaoOriginal(c);
            setCotacao(c);
            formik.setValues(c);
            if (c.estadoId === 30) {
                await getDepartamentos();
            }
            setCurrentState(c.estadoId);
            await getContacto(c.contactoId);
            handleState(c.estadoId);
            //setPageLoad(false);
        }
        catch (error) {
            console.log('Erro ao obter cotação: ', error);
        }
        try {
        }
        catch (error) {
            console.log('Erro ao obter histórico da cotação: ', error);
        }
    };
    const handleFiles = (doc, file, hist) => {
        setDocumentosList(prevData => {
            const docIndex = prevData.findIndex(d => d.uuid === doc.uuid);
            if (docIndex !== -1) {
                // Se o documento já existe, substitui na posição correta
                const updatedDocs = [...prevData];
                updatedDocs[docIndex] = { ...prevData[docIndex], ...doc };
                return updatedDocs;
            }
            else {
                // Se não existir, adiciona o novo documento
                return [...prevData, doc];
            }
        });
        setFiles(prevFiles => {
            const fileIndex = files.findIndex(f => f.name === file.name);
            if (fileIndex !== -1) {
                // Se já existe um ficheiro com o mesmo ID, substitui
                const updatedFiles = [...prevFiles];
                updatedFiles[fileIndex] = file;
                return updatedFiles;
            }
            else {
                // Se não existir, adiciona o novo
                return [...prevFiles, file];
            }
        });
    };
    const formik = useFormik({
        initialValues: {
            id: 0,
            iidCotacao: 0,
            iidAno: 0,
            numeroCotacao: '',
            clienteId: $state.params.idEmpresa,
            contactoId: 0,
            estadoId: 0,
            cancelamentoId: null,
            descricaoServico: null,
            metodologiasTrabalho: null,
            condicoesEspecificas: null,
            active: 1
        },
        enableReinitialize: false,
        validateOnChange: false,
        validateOnBlur: false,
        validateOnMount: false,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setDisableButton(true);
            const currentDate = moment().format();
            if (values.descricaoServico == '<p></p>')
                values.descricaoServico = null;
            if (values.metodologiasTrabalho == '<p></p>')
                values.metodologiasTrabalho = null;
            if (values.condicoesEspecificas == '<p></p>')
                values.condicoesEspecificas = null;
            //Procura pelo estado atual da variavel para atualizar a data do estado
            switch (values.estadoId) {
                case null:
                    values.dataAvaliacao = currentDate;
                    break;
                case 20:
                    values.dataAvaliacao = currentDate;
                    break;
                case 30:
                    values.dataEmCotacao = currentDate;
                    break;
                case 40:
                    values.dataEmArquivamento = currentDate;
                    break;
                case 50:
                    values.dataEdicaoDepartamentoExterno = currentDate;
                    break;
                case 60:
                    values.dataArquivado = currentDate;
                    break;
                case 70:
                    values.dataConclusao = currentDate;
                    break;
                default:
                    break;
            }
            const hist = await handleHistory(values);
            let cot;
            // no primeiro estado tem de primeiro criar a cotação e só depois registar os documentos
            try {
                cot = await CrmService.saveCotacao(values, documentosList, hist);
            }
            catch (error) {
                console.log('Erro ao criar cotação', error);
            }
            if (cot && files.length > 0) {
                await uploadFiles();
            }
            if (values.estadoId == 20) {
                $state.go('app.crm.cotacoes.formEdit', { idEmpresa: values.clienteId, id: cot.id });
            }
            else if (values.estadoId == 50) {
                $state.go('app.crm.empresas.details', { id: $state.params.idEmpresa });
            }
            else {
                location.reload();
            }
            setDisableButton(false);
        }
    });
    const uploadFiles = async () => {
        const formData = new FormData();
        for (let f of files) {
            formData.append('file', f, f.name);
            try {
                // Upload da nova imagem
                const response = await fetch('/api/Upload/crm/upload', {
                    method: 'POST',
                    body: formData
                });
                if (response.ok) {
                    const content = await response.json();
                    //return content.result;
                }
                else {
                    //console.log(response);
                    console.error('Erro ao adicionar ficheiro');
                }
            }
            catch (error) {
                console.error('Error uploading file:', error);
            }
        }
    };
    const handleHistory = async (cot) => {
        const fields = [
            { field: 'estadoId', name: 'Estado', options: estados }, // envia os estados para registar o nome em vez do id
            { field: 'departamentoDestino', name: 'Departamento Destino', options: departamentos },
            { field: 'responsavelDepartamento', name: 'Responsável no Departamento' },
            { field: 'titulo', name: 'Título' },
            { field: 'descricaoPedido', name: 'Descrição do Pedido' },
            { field: 'descricaoServico', name: 'Descrição do Serviço', dontCheckChanges: true }, // noCheckChanges: true -> Apenas regista alterações no campo: X (estes campos têm HTML do editor de texto)
            { field: 'metodologiasTrabalho', name: 'Metodologias de Trabalho', dontCheckChanges: true },
            { field: 'cancelamentoId', name: 'Motivo de Cancelamento', options: motivos },
            { field: 'condicoesEspecificas', name: 'Condições Específicas', dontCheckChanges: true },
            { field: 'motivoArquivamento', name: 'Discriminazação da não adjudicação' },
            { field: 'notasComercial', name: 'Notas Comerciais' },
            { field: 'notasDepartamentoExterno', name: 'Notas Departamento Externo' },
            { field: 'total', name: 'Total' }
        ];
        try {
            const h = await historicoAlteracoes(cotacaoOriginal, cot, fields, userId);
            return h;
        }
        catch (error) {
            console.log(error);
        }
        return null;
    };
    const handleState = (stateId) => {
        // recebe o estado da cotação e retorna o componente (a página) consoante o estado
        switch (stateId) {
            case 10:
                // Aberto
                formik.setFieldValue('dataAbertura', moment().format());
                formik.setFieldValue('estadoId', 10);
                setGrupo1(false);
                break;
            case 20:
                // Avaliação Prévia
                setDocsReadOnly(false);
                break;
            case 30:
                // Em Cotação
                setShowLinhasCotação(true);
                setShowGrupo2(true);
                break;
            case 40:
                // Em Arquivamento
                setShowMotivoArquivamento(true);
                setDocsReadOnly(true);
                break;
            case 50:
                // Edição Departamento Externo
                setShowLinhasCotação(true);
                setShowGrupo2(true);
                break;
            case 60:
                // Arquivado
                setShowMotivoArquivamento(true);
                setDocsReadOnly(true);
                break;
            case 70:
                // Conlcuído
                setShowLinhasCotação(true);
                setDisableGrupo2(true);
                setShowGrupo2(true);
                setDocsReadOnly(true);
                break;
            default:
                break;
        }
    };
    const handleDialogData = (values) => {
        if (values.departamentoDestino !== undefined && values.pessoaResponsavel !== undefined && values.notasComercial !== undefined) {
            let temp = formik.values.estadoId;
            formik.setFieldValue('departamentoDestino', values.departamentoDestino);
            formik.setFieldValue('responsavelDepartamento', values.pessoaResponsavel.id);
            formik.setFieldValue('notasComercial', values.notasComercial);
            formik.setFieldValue('estadoId', 50);
            formik.handleSubmit();
        }
    };
    // Alguma coisa está a fazer o formik renderizar a cada caracter escrito (causa delay ao escrever)
    // Não consgui perceber o porquê
    // Validate TextFields
    const validate = (state) => {
        let valid = false;
        switch (state) {
            case 10:
                if (tituloRef.current?.value == '') {
                    setTituloError('Preenchimento obrigatório.');
                }
                else {
                    setTituloError('');
                    formik.setFieldValue('titulo', tituloRef.current?.value);
                }
                if (descricaoPedidoRef.current?.value == '') {
                    setDescricaoPedidoError('Preenchimento obrigatório.');
                }
                else {
                    setDescricaoPedidoError('');
                    formik.setFieldValue('descricaoPedido', descricaoPedidoRef.current?.value);
                }
                if (descricaoPedidoRef.current?.value.length > 0 && tituloRef.current?.value.length > 0) {
                    valid = true;
                }
                break;
            case 40:
                if (cancelamentoMotivoRef.current?.value == '' || cancelamentoMotivoRef.current?.value == null) {
                    setCancelamentoMotivoError('Preenchimento obrigatório.');
                }
                else {
                    setCancelamentoMotivoError('');
                    formik.setFieldValue('cancelamentoId', cancelamentoMotivoRef.current?.value);
                    valid = true;
                }
                if (motivoArquivamentoRef.current?.value == '') {
                    setMotivoArquivamentoError('Preenchimento obrigatório.');
                    valid = false;
                }
                else {
                    setMotivoArquivamentoError('');
                    formik.setFieldValue('motivoArquivamento', motivoArquivamentoRef.current?.value);
                    valid = true;
                }
                break;
            case 50:
                if (notasDepartamentoExternoRef.current?.value == '') {
                    setNotasDepartamentoExternoError('Preenchimento obrigatório.');
                }
                else {
                    setNotasDepartamentoExternoError('');
                    formik.setFieldValue('notasDepartamentoExterno', notasDepartamentoExternoRef.current?.value);
                    valid = true;
                }
                break;
            default:
                // Utilizado para quando é alterado os campos de caracterização de texto da cotação (Continua no estado -> 30, são campos de texto livre)
                valid = true;
                break;
        }
        if (valid) {
            setTituloError('');
            setDescricaoPedidoError('');
            formik.handleSubmit();
        }
    };
    const saveButtons = useMemo(() => {
        switch (currentState) {
            case 10:
                return (<Button variant='contained' onClick={() => {
                        formik.setFieldValue('estadoId', 20);
                        validate(10);
                    }} disabled={disableButton}>
            Submeter avaliação prévia
          </Button>);
            case 20:
                return (<>
            <Stack direction='column' spacing={2}>
              <Stack direction='row' justifyContent='flex-end' alignItems='center' spacing={2}>
                <Button variant='contained' color='warning' onClick={() => {
                        formik.setFieldValue('estadoId', 40);
                        formik.handleSubmit();
                    }} disabled={disableButton}>
                  Arquivar
                </Button>
                <Button variant='contained' color='success' onClick={() => {
                        formik.setFieldValue('estadoId', 30);
                        formik.handleSubmit();
                    }} disabled={disableButton}>
                  Avançar para Cotação
                </Button>
              </Stack>
            </Stack>
          </>);
            case 30:
                setShowLinhasCotação(true);
                setShowGrupo2(true);
                return (<>
            <Button variant='contained' color='warning' onClick={() => {
                        showModal(CotacaoDialog, {
                            CrmService: CrmService,
                            title: 'Cotação - Solicitar dados a departamento externo',
                            departamentos: departamentos,
                            onClose: handleDialogData
                        });
                    }} disabled={disableButton}>
              Solicitar dados a departamento externo IEP
            </Button>
            <Button variant='contained' color='success' onClick={() => {
                        setDisableButton(true);
                        formik.setFieldValue('estadoId', 70);
                        formik.handleSubmit();
                    }} disabled={disableButton}>
              Marcar conforme, pronta a enviar ao cliente
            </Button>
          </>);
            case 40:
                return (<Button variant='contained' onClick={() => {
                        formik.setFieldValue('estadoId', 60);
                        validate(40);
                    }} disabled={disableButton}>
            Fechar Pedido de Cotação
          </Button>);
            case 50:
                setShowLinhasCotação(true);
                setShowGrupo2(true);
                return (<Button variant='contained' onClick={() => {
                        formik.setFieldValue('estadoId', 30);
                        validate(50);
                    }} disabled={disableButton}>
            Devolver cotação ao departamento comercial
          </Button>);
            case 60:
                break;
            case 70:
                break;
            default:
                return null;
        }
    }, [currentState, disableButton]);
    // ao adicionar/remover linhas de cotação atualiza o total da cotação
    const updateTotalCotacao = (value, desconto) => {
        if (value) {
            formik.setFieldValue('total', (Math.round((value + Number.EPSILON) * 100) / 100).toString().replace('.', ','));
            formik.setFieldValue('totalComDesconto', (Math.round((desconto + Number.EPSILON) * 100) / 100).toString().replace('.', ','));
        }
    };
    useEffect(() => {
        if (userId === 0) {
            getUserId();
        }
        getEstados();
        if ($state.params.id !== undefined) {
            setShowHistory(true);
            fetchData();
        }
        else {
            handleState(10);
            setDocCotacao({
                id: null,
                firstState: true
            });
            handleStepper(null);
            setPageLoad(false);
        }
    }, [$state.params.id]);
    // empresa
    useEffect(() => {
        if (!empresa) {
            getEmpresa();
            getContactosAssociadosEmpresa();
        }
    }, [empresa]);
    useEffect(() => {
        if (estados.length > 0) {
            getHistorico();
        }
    }, [estados, cotacao]);
    return (<>
      {!pageLoad ? (<Box sx={{ mt: 2 }}>
          <Breadcrumbs aria-label='breadcrumb'>
            <Link underline='none' color='inherit'>
              CRM
            </Link>
                  <Link underline='hover' color='text.primary' href={$state.href('app.crm.empresas.list')}>
                         Clientes
                       </Link>


              <Link underline='hover' color='text.primary'>
              Cotação
            </Link>
             <Link underline='hover' color='text.primary'>
              {formik.values.numeroCotacao === '' ? 'Adicionar' : `Cotação - ${formik.values.numeroCotacao} - `}
            </Link>
          </Breadcrumbs>
          <History lista={hist} title='Histórico da Cotação' openHistory={openHistory} onClose={() => setOpenHistory(false)}></History>
          <Stack direction='row' spacing={2} alignItems='center'>

            <Typography variant='h5'>{formik.values.numeroCotacao === '' ? 'Nova Cotação' : `Cotação - ${formik.values.numeroCotacao} - `}</Typography>

            {showHistory ? (<Tooltip title='Histórico da Cotação' placement='right'>
                <IconButton color='primary' onClick={() => setOpenHistory(true)}>
                  <MdiIcon path={mdiHistory}/>
                </IconButton>
              </Tooltip>) : (<></>)}

            <Typography variant='h6'>{formik.values?.titulo}</Typography>
          </Stack>

          <StepperComponent steps={steps} activeStep={activeStep}></StepperComponent>

          {empresa?.bloqueadoPrimavera == 1 ? (<Box width='100%' alignItems='center' justifyContent='center' display='flex'>
              <Typography variant='subtitle1' color='#db4437' fontWeight='bold'>
                Cliente bloqueado financeiramente
              </Typography>
            </Box>) : (<></>)}

          {empresa ? (<Box sx={{ mt: 3 }}>
              <InfoContactoCliente $state={$state} empresa={empresa} edit={false}></InfoContactoCliente>
            </Box>) : (<></>)}

          <form>
            {currentState === 10 ? (<>
                <Grid item xs={12} md={12} lg={12} sx={{ mt: 2 }}>
                  <Autocomplete disablePortal options={options || []} // Evita erro se options estiver undefined
             getOptionLabel={option => (typeof option === 'string' ? option : option.nome || '')} value={options?.find(option => option.id === formik.values?.contactoId) || null} noOptionsText='Pesquise pelo nome do Contacto' loadingText='A carregar contactos ...' onChange={(event, newValue) => {
                    if (newValue == null) {
                        formik.setFieldValue('contactoId', null);
                    }
                    else {
                        formik.setFieldValue('contactoId', newValue.id);
                    }
                }} renderOption={(props, option) => (<ListItem {...props} key={option.id} dense>
                        <ListItemText primary={option.nome} secondary={`Email: ${option.email || 'Sem email'} | Ref. Primavera: ${option.refContactoPrimavera}`}/>
                      </ListItem>)} renderInput={params => (<TextField {...params} label='Contacto' variant='outlined' size='small' fullWidth error={Boolean(formik.touched.contactoId && formik.errors.contactoId)} helperText={formik.touched.contactoId && formik.errors.contactoId ? formik.errors.contactoId : ''}/>)}/>
                </Grid>
              </>) : (<>
                {contacto ? (<Box sx={{ mt: 3 }}>
                    <InfoContactoCliente $state={$state} pessoa={contacto} edit={false}></InfoContactoCliente>
                  </Box>) : (<></>)}
              </>)}

            <Grid container spacing={2} sx={{ mt: 1 }}>
              {currentState === 10 ? (<Grid item xs={12} md={12} lg={12}>
                  <TextField id='titulo' name='titulo' label='Titulo' color='info' size='small' inputRef={tituloRef} fullWidth disabled={grupo1} error={!!tituloError} helperText={tituloError}/>
                </Grid>) : (<></>)}

              <Grid item xs={12} md={12} lg={12}>
                <TextField id='descricaoPedido' name='descricaoPedido' label='Descrição do pedido fornecido pelo cliente' color='info' size='small' multiline rows={3} inputRef={descricaoPedidoRef} value={formik.values?.descricaoPedido} fullWidth disabled={grupo1} error={!!descricaoPedidoError} helperText={descricaoPedidoError}/>
              </Grid>

              <Box id='docs-associados'></Box>
              {currentState === 20 && (<Grid item xs={12} md={12} lg={12} sx={{ mt: 1 }}>
                  <DocumentosAssociados $state={$state} CrmService={CrmService} cotacao={cotacao} userId={userId} readOnly={docsReadOnly}/>
                </Grid>)}

              {showMotivoArquivamento ? (<Grid item xs={12} md={12} lg={12} sx={{ mt: 1 }}>
                  <TextField id='cancelamentoId' name='cancelamentoId' label='Motivo da não adjudicação' color='info' size='small' onChange={e => formik.setFieldValue('cancelamentoId', e.target.value)} inputRef={cancelamentoMotivoRef} value={formik.values?.cancelamentoId} fullWidth disabled={currentState === 60 ? true : false} error={!!cancelamentoMotivoError} helperText={cancelamentoMotivoError} select>
                    <MenuItem value={''} disabled></MenuItem>
                    {motivos &&
                    motivos.map(x => (<MenuItem value={x.id} key={x.id}>
                          {x.designacao}
                        </MenuItem>))}
                  </TextField>
                </Grid>) : (<></>)}
              {showMotivoArquivamento ? (<Grid item xs={12} md={12} lg={12} sx={{ mt: 1 }}>
                  <TextField id='motivoArquivamento' name='motivoArquivamento' label='Discriminazação da não adjudicação' color='info' size='small' multiline rows={3} inputRef={motivoArquivamentoRef} value={formik.values?.motivoArquivamento} fullWidth disabled={currentState === 60 ? true : false} error={!!motivoArquivamentoError} helperText={motivoArquivamentoError}/>
                </Grid>) : (<></>)}

              {showLinhasCotação ? (<>
                  <Grid item xs={12} md={12} lg={12} sx={{ mt: 1 }}>
                    <LinhasCotacao $state={$state} CrmService={CrmService} client={$state.params.empresaId} user={userId} cotacao={cotacao} updateTotalCotacao={updateTotalCotacao}/>
                  </Grid>

                  <Grid item xs={0} md={5} lg={5} sx={{ mt: 1 }}></Grid>

                  <Grid item xs={12} md={7} lg={7} sx={{ mt: 1 }}>
                    <Stack direction='row' spacing={2} justifyContent='center' alignItems='center'>
                      <Typography>Total, sem IVA: </Typography>
                      <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '150px',
                    height: 40,
                    borderRadius: '15px',
                    border: '1px solid #e0e0e0',
                    overflow: 'hidden',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    ml: 1
                }}>
                        <Typography>{formik.values.total} €</Typography>
                      </Box>

                      <Typography sx={{ ml: 2 }}>Total, com Desconto: </Typography>
                      <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '150px',
                    height: 40,
                    borderRadius: '15px',
                    border: '1px solid #e0e0e0',
                    overflow: 'hidden',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)'
                }}>
                        <Typography>{formik.values.totalComDesconto} €</Typography>
                      </Box>
                    </Stack>
                  </Grid>
                </>) : (<></>)}

              {showGrupo2 ? (<>
                  <Grid item xs={12} md={12} lg={12}>
                    <Stack direction='row' spacing={2} alignItems='center'>
                      <Typography variant='h6' sx={{ color: 'black' }}>
                        Caracterização da Cotação
                      </Typography>

                      {currentState < 60 ? (<Tooltip title={'Guardar alterações'}>
                          <IconButton color='primary' onClick={() => {
                        validate(30);
                    }}>
                            <MdiIcon path={mdiContentSave} sx={{ color: '#1976D2' }}/>
                          </IconButton>
                        </Tooltip>) : (<></>)}
                    </Stack>
                  </Grid>

                  <Grid item xs={12} md={12} lg={12}>
                    <Stack direction='row' justifyContent='flex-start' alignItems='center' spacing={2}>
                      <Typography variant='subtitle1' sx={{ color: 'black' }}>
                        Caso pretenda incluir imagens, preencha o seguinte documento e submeta na secção de{' '}
                        <Link component='button' underline='hover' color='black' onClick={() => {
                    const el = document.getElementById('docs-associados');
                    if (el)
                        el.scrollIntoView({ behavior: 'smooth' });
                }} sx={{ mb: '1px' }}>
                          Documentos Associados
                        </Link>
                      </Typography>
                      <Button variant='contained' size='small' onClick={() => {
                    window.open(CrmService.generatePreviewDoc($state.params.id), '_blank');
                }}>
                        Descarregar Documento
                      </Button>
                    </Stack>
                  </Grid>

                  <Grid item xs={12} md={12} lg={12}>
                    <Stack spacing={2}>
                      <Box>
                        <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}>
                          Âmbito da Proposta
                        </Typography>
                        <TextEditor onContentChange={handleEditorChange} label={'descricaoServico'} disabled={disableGrupo2} defaultValue={formik.values.descricaoServico}/>
                      </Box>

                      <Box>
                        <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}>
                          Metodologias de trabalho
                        </Typography>
                        <TextEditor onContentChange={handleEditorChange} label={'metodologiasTrabalho'} disabled={disableGrupo2} defaultValue={formik.values.metodologiasTrabalho}/>
                      </Box>

                      <Box>
                        <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }}>
                          Condições específicas
                        </Typography>
                        <TextEditor onContentChange={handleEditorChange} label={'condicoesEspecificas'} disabled={disableGrupo2} defaultValue={formik.values.condicoesEspecificas}/>
                      </Box>

                      {currentState === 50 ? (<TextField id='notasComercial' name='notasComercial' label='Descrição das solicitações a pedir ao departamento externo' color='info' size='small' multiline rows={3} value={formik.values?.notasComercial} fullWidth disabled={currentState === 50 ? true : false}/>) : (<></>)}

                      <TextField id='notasDepartamentoExterno' name='notasDepartamentoExterno' label='Notas do departamento externo passadas pelo departamento comercial' color='info' size='small' multiline rows={3} inputRef={notasDepartamentoExternoRef} value={formik.values?.notasDepartamentoExterno} fullWidth disabled={currentState === 50 ? false : true} error={!!notasDepartamentoExternoError} helperText={notasDepartamentoExternoError}/>
                    </Stack>
                  </Grid>
                </>) : (<></>)}
            </Grid>

            <Stack spacing={2} direction='row' alignItems='center' justifyContent='flex-end' sx={{ mt: 2 }}>
              {saveButtons}
            </Stack>
          </form>
        </Box>) : (<Stack direction='row' justifyContent='center' alignItems='flex-start' sx={{ mt: 4 }}>
          <CircularProgress size={50}/>
        </Stack>)}
    </>);
};
export default CrmCotacaoForm;
